<script setup lang="ts">
type Props = {
  isActive: boolean
}

defineProps<Props>()
</script>

<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 100 100"
    class="header-burger-icon"
    :class="{ 'header-burger-icon--active': isActive }"
    :aria-expanded="!isActive"
  >
    <path
      d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
    />
    <path d="M 20,50 H 80" />
    <path
      d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
    />
  </svg>
</template>

<style lang="scss" scoped>
.header-burger-icon {
  width: 30px;
  height: 30px;

  path {
    fill: none;
    stroke: var(--ui-secondary);
    stroke-width: 6;
    stroke-linecap: round;
    transition:
      stroke-dasharray 0.2s cubic-bezier(0.4, 0, 0.2, 1),
      stroke-dashoffset 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    &:nth-child(1) {
      stroke-dasharray: 60 207;
    }

    &:nth-child(2) {
      stroke-dasharray: 60 60;
    }

    &:nth-child(3) {
      stroke-dasharray: 60 207;
    }
  }

  &--active {
    path {
      &:nth-child(1) {
        stroke-dasharray: 90 207 !important;
        stroke-dashoffset: -134;
      }

      &:nth-child(2) {
        stroke-dasharray: 1 60 !important;
        stroke-dashoffset: -30;
      }

      &:nth-child(3) {
        stroke-dasharray: 90 207 !important;
        stroke-dashoffset: -134;
      }
    }
  }
}
</style>
